import { useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOPICS = [
  "Best Online Casinos in Canada 2026",
  "How to Choose a Safe Online Casino",
  "Top Slot Games with Highest RTP",
  "No Deposit Bonus Guide for Beginners",
  "Crypto Casino vs Traditional Casino",
  "Live Casino Games Explained",
  "How to Win at Online Blackjack",
  "Best Mobile Casino Apps 2026",
  "Online Casino Bonuses: Complete Guide",
  "Responsible Gambling Tips",
];

export default function BlogGenerator() {
  const [topic, setTopic] = useState("");
  const [customTopic, setCustomTopic] = useState("");
  const [generating, setGenerating] = useState(false);
  const [generated, setGenerated] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [savedTopic, setSavedTopic] = useState("");

  const generate = async () => {
    const finalTopic = customTopic || topic;
    if (!finalTopic) return alert("Please select or enter a topic!");
    setGenerating(true);
    setGenerated(null);
    setSaved(false);
    setSavedTopic(finalTopic);

    try {
      const response = await fetch(`${API}/generate-blog`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ topic: finalTopic })
      });
      const parsed = await response.json();
      if (!response.ok) throw new Error(parsed.detail || "Generation failed");
      setGenerated(parsed);
    } catch (err) {
      alert("Generation failed: " + err.message);
    }
    setGenerating(false);
  };

  const getImage = (t) => {
    const tl = (t || "").toLowerCase();
    if (tl.includes("slot")) return "https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=800";
    if (tl.includes("blackjack") || tl.includes("poker")) return "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=800";
    if (tl.includes("bonus") || tl.includes("free spin")) return "https://images.unsplash.com/photo-1605870445919-838d190e8e1b?w=800";
    if (tl.includes("mobile") || tl.includes("app")) return "https://images.unsplash.com/photo-1567443024551-f3e3cc2be870?w=800";
    if (tl.includes("crypto") || tl.includes("bitcoin")) return "https://images.unsplash.com/photo-1621761191319-c6fb62004040?w=800";
    if (tl.includes("live") || tl.includes("dealer")) return "https://images.unsplash.com/photo-1541278107931-e006523892df?w=800";
    if (tl.includes("safe") || tl.includes("secure") || tl.includes("responsible")) return "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800";
    if (tl.includes("canada") || tl.includes("canadian")) return "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=800";
    return "https://images.unsplash.com/photo-1606167668584-78701c57f13d?w=800";
  };

  const saveBlog = async () => {
    if (!generated) return;
    setSaving(true);
    try {
      const loginRes = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: "admin@playspiro.com", password: "admin123" })
      });
      const { token } = await loginRes.json();
      const slug = generated.title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
      const res = await fetch(`${API}/blogs`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify({
          title: generated.title,
          slug,
          excerpt: generated.excerpt,
          content: generated.content,
          tags: generated.tags,
          meta_title: generated.seo_title || generated.title,
          meta_description: generated.seo_description || generated.excerpt,
          status: "published",
          author: "PlaySpiro Team",
          category: "Casino Guide",
          featured_image: getImage(savedTopic)
        })
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(JSON.stringify(err.detail));
      }
      setSaved(true);
    } catch (err) {
      alert("Save failed: " + err.message);
    }
    setSaving(false);
  };

  return (
    <div style={{minHeight:"100vh",padding:"40px 16px"}}>
      <div style={{maxWidth:"900px",margin:"0 auto"}}>
        
        {/* Header */}
        <div style={{textAlign:"center",marginBottom:"40px"}}>
          <div style={{fontSize:"3rem",marginBottom:"12px"}}>📰</div>
          <h1 style={{color:"white",fontSize:"2rem",fontWeight:"bold",marginBottom:"8px"}}>AI Blog Generator</h1>
          <p style={{color:"rgba(255,255,255,0.5)"}}>Generate SEO-optimized casino blog posts in seconds</p>
        </div>

        {/* Topic Selection */}
        <div style={{background:"rgba(168,85,247,0.08)",border:"1px solid rgba(168,85,247,0.2)",borderRadius:"16px",padding:"24px",marginBottom:"24px"}}>
          <h3 style={{color:"white",marginBottom:"16px",fontSize:"1rem",fontWeight:"600"}}>1. Choose a Topic</h3>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:"8px",marginBottom:"16px"}}>
            {TOPICS.map(t => (
              <button key={t} onClick={() => { setTopic(t); setCustomTopic(""); }}
                style={{padding:"10px 14px",borderRadius:"10px",border:`1px solid ${topic===t?"#a855f7":"rgba(255,255,255,0.1)"}`,background:topic===t?"rgba(168,85,247,0.2)":"rgba(255,255,255,0.03)",color:topic===t?"#a855f7":"rgba(255,255,255,0.6)",cursor:"pointer",fontSize:"0.8rem",textAlign:"left",transition:"all 0.2s"}}>
                {t}
              </button>
            ))}
          </div>
          <div style={{display:"flex",gap:"12px",alignItems:"center"}}>
            <span style={{color:"rgba(255,255,255,0.4)",fontSize:"0.85rem",whiteSpace:"nowrap"}}>Or custom:</span>
            <input
              value={customTopic}
              onChange={e => { setCustomTopic(e.target.value); setTopic(""); }}
              placeholder="Enter your own topic..."
              style={{flex:1,background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:"10px",padding:"10px 14px",color:"white",fontSize:"0.9rem",outline:"none"}}
            />
          </div>
        </div>

        {/* Generate Button */}
        <button onClick={generate} disabled={generating || (!topic && !customTopic)}
          style={{width:"100%",background:generating?"#374151":"linear-gradient(135deg,#a855f7,#7c3aed)",color:"white",border:"none",borderRadius:"12px",padding:"16px",fontSize:"1.1rem",fontWeight:"bold",cursor:generating?"not-allowed":"pointer",marginBottom:"24px",transition:"all 0.2s"}}>
          {generating ? "⏳ Generating blog post..." : "✨ Generate Blog Post with AI"}
        </button>

        {/* Result */}
        {generated && (
          <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(168,85,247,0.2)",borderRadius:"16px",padding:"24px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"20px",flexWrap:"wrap",gap:"12px"}}>
              <div>
                <h2 style={{color:"white",fontSize:"1.3rem",fontWeight:"bold",marginBottom:"4px"}}>{generated.title}</h2>
                <p style={{color:"rgba(255,255,255,0.5)",fontSize:"0.85rem"}}>{generated.excerpt}</p>
              </div>
              <button onClick={saveBlog} disabled={saving || saved}
                style={{background:saved?"#22c55e":saving?"#374151":"linear-gradient(135deg,#22c55e,#16a34a)",color:"white",border:"none",borderRadius:"10px",padding:"10px 20px",fontWeight:"bold",cursor:saving||saved?"not-allowed":"pointer",whiteSpace:"nowrap",fontSize:"0.9rem"}}>
                {saved ? "✅ Published!" : saving ? "Saving..." : "🚀 Publish to Site"}
              </button>
            </div>

            {/* SEO Info */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px",marginBottom:"20px"}}>
              <div style={{background:"rgba(34,197,94,0.08)",border:"1px solid rgba(34,197,94,0.2)",borderRadius:"10px",padding:"12px"}}>
                <div style={{color:"#22c55e",fontSize:"0.7rem",fontWeight:"600",marginBottom:"4px"}}>SEO TITLE</div>
                <div style={{color:"white",fontSize:"0.85rem"}}>{generated.seo_title}</div>
              </div>
              <div style={{background:"rgba(59,130,246,0.08)",border:"1px solid rgba(59,130,246,0.2)",borderRadius:"10px",padding:"12px"}}>
                <div style={{color:"#3b82f6",fontSize:"0.7rem",fontWeight:"600",marginBottom:"4px"}}>META DESCRIPTION</div>
                <div style={{color:"white",fontSize:"0.85rem"}}>{generated.seo_description}</div>
              </div>
            </div>

            {/* Tags */}
            <div style={{display:"flex",gap:"8px",flexWrap:"wrap",marginBottom:"20px"}}>
              {generated.tags?.map(tag => (
                <span key={tag} style={{background:"rgba(168,85,247,0.15)",border:"1px solid rgba(168,85,247,0.3)",borderRadius:"100px",padding:"4px 12px",color:"#a855f7",fontSize:"0.75rem"}}>#{tag}</span>
              ))}
            </div>

            {/* Content Preview */}
            <div style={{background:"rgba(0,0,0,0.2)",borderRadius:"10px",padding:"20px",maxHeight:"400px",overflowY:"auto"}}>
              <div className="blog-content" dangerouslySetInnerHTML={{__html: generated.content}}/>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
